import React from 'react';
import { FadeIn } from './FadeIn';
import { ScaleIcon, ClockIcon, ShoppingCartIcon } from 'lucide-react';
export function SolutionSection() {
  const pillars = [{
    icon: <ScaleIcon className="w-8 h-8 text-bakery-amber" data-id="element-144" />,
    title: 'Pesamos hasta el Agua',
    description: 'Cero adivinanzas. Si sabes leer un número en una balanza, tu pan saldrá perfecto todas las veces.'
  }, {
    icon: <ClockIcon className="w-8 h-8 text-bakery-amber" data-id="element-145" />,
    title: 'Pan en 2 Horas',
    description: 'No necesitas esperar 12 horas. Mi técnica express te permite tener pan fresco en la mesa hoy mismo.'
  }, {
    icon: <ShoppingCartIcon className="w-8 h-8 text-bakery-amber" data-id="element-146" />,
    title: 'Marcas de Walmart & Publix',
    description: 'Te digo exactamente qué harinas y mantequillas comprar para que no pierdas tu dinero.'
  }];
  return <section className="bg-bakery-cream py-24 px-6" data-id="element-147">
      <div className="max-w-6xl mx-auto" data-id="element-148">
        <FadeIn className="text-center mb-16" data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-bakery-brown mb-6" data-id="element-150">
            El Sistema de Precisión en Gramos <br className="hidden md:block" data-id="element-151" />
            <span className="text-bakery-amber italic" data-id="element-152">
              + Fermentación Corta
            </span>
          </h2>
          <p className="text-xl text-bakery-brown/80 max-w-2xl mx-auto" data-id="element-153">
            Un método diseñado específicamente para el ritmo de vida en USA.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-154">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.2} className="h-full" data-id="element-155">
              <div className="bg-white h-full p-8 rounded-2xl shadow-lg shadow-bakery-brown/5 border border-bakery-tan hover:border-bakery-amber/50 transition-colors group" data-id="element-156">
                <div className="w-16 h-16 bg-bakery-tan rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-157">
                  {pillar.icon}
                </div>
                <h3 className="text-2xl font-serif font-bold text-bakery-brown mb-4" data-id="element-158">
                  {pillar.title}
                </h3>
                <p className="text-bakery-brown/70 leading-relaxed" data-id="element-159">
                  {pillar.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}